<template>
    <Card
        :size="`col-md-10 col-lg-8 col-xl-6 max-xl-670 mt-4`"
        :hideHeader="true"
        :hideFooter="false"
        :newLayout="true"
    >
        <template slot="card-body">
            <div class=" d-flex justify-content-center mb-4">
                <svg-rndr
                    svg="warning.svg"
                    :width="110"
                />
            </div>
            <div class="row justify-content-center mb-4 text-center text-white px-md-4">
                <div class="col">
                    <h1 class="h3 mb-2">{{ teaserMessage }}</h1>

                    <p class="mb-0" v-translate>An email has been sent showing your interest in upgrading, a Learn To Trade Representative will contact you shortly to discuss your upgrade options.</p>
                </div>
            </div>
        </template>
        <template slot="card-footer">
            <div class="row justify-content-center">
                <div class="col-12 col-md-auto text-center ml-md-auto">
                    <button
                        class="text-white btn btn-hollow btn--chunky border-white border-white--lightest"
                        v-translate
                        @click.prevent="cancel"
                    >Go Back</button>
                </div>
            </div>
        </template>
    </Card>
</template>

<script>
import { mapMutations } from 'vuex';
import Card from '@C/Card.vue';

export default {
    components: {
        Card
    },
    mounted() {
        this.$store.dispatch('MySubscriptions/sendTeaserEmail');
    },
    methods: {
        ...mapMutations('Widget', [
            'setSelectedUpgrade'
        ]),
        cancel() {
            // Clear the selection and redirect
            this.setSelectedUpgrade({});
            return this.$router.push({ name: 'my-subscriptions' });
        },
    },
    computed: {
        teaserMessage() {
            return this.$store.state.Widget.selectedUpgrade.message ?
                this.$store.state.Widget.selectedUpgrade.message
                : this.$gettext('In order to upgrade to this subscription level, you will need to be on an advanced training programme with Learn To Trade.');
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/stages/MySubscriptions/Teaser.vue